(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('Controller', Controller);

    Controller.$inject = ['$resource','DateUtils'];

    function Controller($resource, DateUtils) {
        var resourceUrl = "api/controller/:id";

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function(data) {
                    return angular.toJson(data);
                }
            }
        })
    }
})();
